import { render } from "./index.vue?vue&type=template&id=4f213d2f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4f213d2f&lang=scss&scoped=true"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f213d2f"]])

export default __exports__